export default "/images/vendor/flag-icons/flags/1x1/pk.svg?45854c457a1d150934b5fdfed36ee455";